import BaseOption from "%/dynamic-components/render-engine/classes/base-option";
import { inspectorTools } from "%/dynamic-components/builder-engine/inspector/inspector-tool-map";

// "Link this element to its entity's page" — carried by the generic
// DynamicApp* display elements (text / image). When Yes, the element
// resolves its bound entity's display page through the host-registered
// entity-page-link resolver (@bloglovin/inspire-engine .../Helpers/
// entity-page-links) and renders as a link to it. Production twin of the
// editor option (%/dynamic-component-editor/options/link-to-entity-page.js)
// — same class name, same persisted option key.
export default class LinkToEntityPage extends BaseOption {
  static userInterfaceComponent = {
    label: "Link To Page",
    component: inspectorTools.RADIO_BAR,
    props: {
      iconSize: 24,
      options: [
        {
          label: "Yes",
          value: true,
        },
        {
          label: "No",
          value: false,
        },
      ],
    },
  };

  static defaultValue = false;
}
